module.exports = __webpack_public_path__ + "static/img/kypt.afd9c858.png";